import { render } from "./LogoAmoba.vue?vue&type=template&id=bc512da8"
import script from "./LogoAmoba.vue?vue&type=script&lang=js"
export * from "./LogoAmoba.vue?vue&type=script&lang=js"
script.render = render

export default script